import React from "react"

const Card = ({ children }) => (
  <div className="mb-14 shadow-lg bg-white rounded-md">{children}</div>
)

export default Card
